
document.addEventListener('DOMContentLoaded', function () {
    function show_hide_color () {
        $('.product-color-swatch-wrapper .swatch').removeClass('hidden');
        $('.variant_list .variant_item .item:not(.active)').each(function () {
            const htmlContent = $(this).attr('data');
            $(this).parents('.variant_list').find(`.swatch[data*='${htmlContent}']`).addClass('hidden');
        });
    }
    show_hide_color();
    $('.product-color-swatch-wrapper .swatch').click(function () {
        $(this).addClass('active').siblings().removeClass('active');
        let variant_id = $(this).data('id');
        let variant_sku = $(this).data('sku');
        let available = $(this).data('varavailable');
        $(this)
            .parents('.product-box')
            .find('.discount')
            .find(`span[data-id=${variant_id}]`)
            .removeClass('hidden')
            .siblings()
            .addClass('hidden');
        $(this)
            .parents('.product-box')
            .find('.discount')
            .find(`img`)
            .removeClass('hidden')
        $(this)
            .parents('.top_wrapper')
            .find('.price_list')
            .find(`.price[data-id=${variant_id}]`)
            .addClass('active')
            .siblings()
            .removeClass('active');
        $(this)
            .parents('.product_item')
            .find(`.variant-img[data-id='${variant_id}']`)
            .removeClass('hidden')
            .siblings()
            .addClass('hidden');
        $(this).parents('.top_wrapper').find('add-cart-button').attr('data-variant-id', variant_id);
        $(this).parents('.buy-card').find('.product-item').attr('data-sku', variant_sku);
        if (available) {
            $(this).parents('.top_wrapper').find('add-cart-button').removeClass('disabled');
            $(this).parents('.top_wrapper').find('add-cart-button').text('ADD TO CART');
        } else {
            $(this).parents('.top_wrapper').find('add-cart-button').addClass('disabled');
            $(this).parents('.top_wrapper').find('add-cart-button').text('SOLD OUT');
        }
        // const productItem = $(this).parents('.product-box').find('.product-item')
        // const price = productItem.data('price')
        // const comPrice = productItem.data('com-price')
        // const discount = productItem.data('discount')
        // const purplePrice = productItem.data('purple-price')
        // const purpleComPrice = productItem.data('purple-com-price')
        // const purpleDiscount = productItem.data('purple-discount')
        // const product2Price = productItem.data('product2-price')
        // const product2ComPrice = productItem.data('product2-com-price')
        // const product2Discount = productItem.data('product2-discount')
        // if (purplePrice) {
        //     if (variant_id == '44865963720904') {
        //         $(this).parents('.top_wrapper').find('.cur_price').text(purplePrice);
        //         $(this).parents('.top_wrapper').find('.compare_price').text(purpleComPrice);
        //         $(this).parents('.product_item').find('.discount').find('span').text(purpleDiscount);

        //     } else {
        //         $(this).parents('.top_wrapper').find('.price.active').find('.cur_price').text(price);
        //         $(this).parents('.top_wrapper').find('.price.active').find('.compare_price').text(comPrice);
        //         $(this).parents('.product_item').find('.discount').find('span').text(discount);
        //     }
        // }
    });
    $('.variant_list .variant_item .item,.product_select .select_item .item').click(function () {
        if (!$(this).hasClass('active')) {
            $(this).addClass('active').siblings().removeClass('active');

            if ($(this).attr('data') == 'custom-item') {
                // $(this).parents('.top_wrapper').find('.square').hide();
                $(this).parents('.product_item').find('.corner-marker').hide();
                $(this).parents('.product_item').find('a').attr('href', $(this).data('url'));
                $(this).parents('.top_wrapper').find('.product_color_item').eq(0).removeClass('active');
                $(this).parents('.top_wrapper').find('.product_color_item').eq(1).addClass('active');
                $(this).parents('.top_wrapper').find('h3').eq(0).addClass('hidden');
                $(this).parents('.top_wrapper').find('h3').eq(1).removeClass('hidden');
                $(this).parents('.top_wrapper').find('h4').eq(0).addClass('hidden');
                $(this).parents('.top_wrapper').find('h4').eq(1).removeClass('hidden');
                $(this).parents('.top_wrapper').find('.product-title').eq(0).addClass('hidden');
                $(this).parents('.top_wrapper').find('.product-title').eq(1).removeClass('hidden');
                $(this).parents('.product_item').find('.discount').eq(0).addClass('hidden');
                $(this).parents('.product_item').find('.discount').eq(1).removeClass('hidden');
                $(this).parents('.top_wrapper').find('.discount').eq(0).addClass('hidden');
                $(this).parents('.top_wrapper').find('.discount').eq(1).removeClass('hidden');
                $(this).parents('.product_item').find('.custom_tag').eq(0).addClass('hidden');
                $(this).parents('.product_item').find('.custom_tag').eq(1).removeClass('hidden');
                $(this)
                    .parents('.top_wrapper')
                    .find(`.product_color_item.active .product-color-swatch-wrapper .swatch`)
                    .eq(0)
                    .click();
                if ($(this).parents('.product_item').hasClass('openfit2plus')) {
                    $(this).parents('.product_item').find('.variant_item').find('.item.active').text('USB-C')
                }
            } else {
                if ($(this).parents('.product_item').find('.product_color_item').length > 1) {
                    $(this).parents('.product_item').find('.corner-marker').show();
                    $(this).parents('.product_item').find('a').attr('href', $(this).parents('.product_info').data('url'));
                    $(this).parents('.product_item').find('h3').eq(0).find('.square').show();
                    $(this).parents('.product_item').find('h4').eq(0).find('.square').show();
                    $(this).parents('.top_wrapper').find('.product_color_item').eq(1).removeClass('active');
                    $(this).parents('.top_wrapper').find('.product_color_item').eq(0).addClass('active');
                    $(this).parents('.top_wrapper').find('h3').eq(1).addClass('hidden');
                    $(this).parents('.top_wrapper').find('h3').eq(0).removeClass('hidden');
                    $(this).parents('.top_wrapper').find('h4').eq(1).addClass('hidden');
                    $(this).parents('.top_wrapper').find('h4').eq(0).removeClass('hidden');
                    $(this).parents('.top_wrapper').find('.product-title').eq(1).addClass('hidden');
                    $(this).parents('.top_wrapper').find('.product-title').eq(0).removeClass('hidden');
                    $(this).parents('.top_wrapper').find('.discount').eq(1).addClass('hidden');
                    $(this).parents('.top_wrapper').find('.discount').eq(0).removeClass('hidden');
                    $(this).parents('.product_item').find('.discount').eq(1).addClass('hidden');
                    $(this).parents('.product_item').find('.discount').eq(0).removeClass('hidden');
                    $(this).parents('.product_item').find('.custom_tag').eq(0).removeClass('hidden');
                    $(this).parents('.product_item').find('.custom_tag').eq(1).addClass('hidden');
                }
                if ($(this).parents('.product_item').hasClass('openfit2plus')) {
                    $(this).parents('.product_item').find('.variant_item').find('.item.active').text('USB-C + Wireless Charging')
                }

                if ($(this).attr('data') == 'No Adapter') {
                    $(this).parents('.top_wrapper').find('.square').hide();
                } else {
                    $(this).parents('.top_wrapper').find('.square').show().css('display', 'inline');
                }

                // if ($(this).parents('.product_item').hasClass('openmeet')) {
                //     if ($(this).attr('data') == 'No Adapter') {
                //         $(this).parents('.product_item').find('.discount').find('span').text('30% OFF')
                //     } else {
                //         $(this).parents('.product_item').find('.discount').find('span').text('25% OFF')
                //     }
                // }

                show_hide_color();
                $(this)
                    .parents('.top_wrapper')
                    .find(`.product_color_item.active .product-color-swatch-wrapper .swatch:not(.hidden)`)
                    .eq(0)
                    .click();
            }
        }
    });

    // 防止重复绑定导致点击事件触发两次：先解绑再绑定
    $('.product_info .product-info-wrapper').off('click').on('click', function () {
        $(this).toggleClass('active')
        $(this).find('.product_select').slideToggle()
    })

    $('.product_info.opencomm2uc-2025-upgrade .variant_list .variant_values .item:first-child').click();
    $('.product_info.openfit2plus .variant_list .variant_values .item:first-child').click();
    $('.product_item.openmeet .variant_values .item:nth-child(2)').click();

    $('.product_info.openmeet .variant_item.active .item:last-child').click();
    $(".product_info.openswimpro .swatch[data-id='42098813861987']").click();
    $(".product_info.openmove .swatch[data-id='39330540847203']").click();
    $(".product_info .swatch[data-id='43683712729187']").click();
    $(".product_info .swatch[data-id='43789821050979']").click();
    $(".product_info .swatch[data-id='43823269871715']").click();
    $(".product_info .swatch[data-id='43866379419747']").click();
    $(".product_info .swatch[data-id='43637261697123']").click();

    $('.bottom_item .bottom_cart .add_btn,.slide_card .slide_bottom .add_btn').click(function () {

        $(this).parents('.bottom_item').find('add-cart-button').eq(0).click();

    });
    $('.top_wrapper add-cart-button').click(function () {
        let id = $(this).attr('data-variant-id');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { id: id },
            dataType: 'json',
            success: function () {
                window.location.href = '/cart';
            },
        });
    });
});
